import React from 'react';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import '@popperjs/core';
import '../Icon/ImgIcon.esm.js';
import { LoadingIcon } from '../Icon/SemanticIcons.esm.js';

/**
 * Container for the main content of the card.
 */
function CardBody({ children, addClassName, dataMetrics, dataTestId, isLoading = false, overflow, ...passThrough }) {
    return (React.createElement("div", { "data-metrics": dataMetrics, "data-testid": dataTestId || "card-body", className: classNames("tw-box-border tw-font-lato tw-flex-1 tw-w-full tw-p-4 tw-text-default dark:tw-text-dark-bg", overflow &&
            "tw-overflow-auto tw-scrollbar-small dark:tw-scrollbar-track-dark dark:tw-scrollbar-thumb-dark dark:tw-scrollbar-corner-dark", addClassName), ...passThrough }, isLoading ? (React.createElement("div", { className: "tw-flex tw-items-center tw-justify-center tw-h-full" },
        React.createElement(LoadingIcon, { size: "3xl" }))) : (children)));
}

export { CardBody };
//# sourceMappingURL=CardBody.esm.js.map
